var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import sort, { stringSort_depricated } from "@domains/utils/sort";
import { MY_POSITIONS, MY_POSITIONS_APPLY_SORT_, MY_POSITIONS_CLEAR_DATA, MY_POSITIONS_CLEAR_SORT, MY_POSITIONS_ERROR, MY_POSITIONS_HIDE_ERROR, MY_POSITIONS_START_LOADER, MY_POSITIONS_STOP_LOADER, } from "../interface/MyPositions";
var initialState = {
    data: {},
    //   presetWatchlist: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    sortData: {
        sortStates: [],
        sortState: {},
        sortedData: {},
    },
};
var applySorting = function (sortData) {
    var _a, _b;
    var pinStockList = [], unpinStockList = [];
    (_a = sortData.sortedData) === null || _a === void 0 ? void 0 : _a.stockList.map(function (item) {
        if (item.isPin === "1") {
            pinStockList.push(item);
        }
        else {
            unpinStockList.push(item);
        }
    });
    if (sortData &&
        sortData.sortedData &&
        ((_b = sortData.sortedData.stockList) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        if (sortData.sortState.type && sortData.sortState.type === "string") {
            pinStockList = stringSort_depricated(pinStockList, sortData.sortState.key, sortData.sortState.order);
            unpinStockList = stringSort_depricated(unpinStockList, sortData.sortState.key, sortData.sortState.order);
        }
        else {
            pinStockList = sort(pinStockList, sortData.sortState.key, sortData.sortState.order);
            unpinStockList = sort(unpinStockList, sortData.sortState.key, sortData.sortState.order);
        }
    }
    var sortedData = {
        stockList: [],
    };
    (pinStockList === null || pinStockList === void 0 ? void 0 : pinStockList.length) > 0 &&
        pinStockList.map(function (item) {
            sortedData.stockList.push(item);
        });
    (unpinStockList === null || unpinStockList === void 0 ? void 0 : unpinStockList.length) > 0 &&
        unpinStockList.map(function (record) {
            sortedData.stockList.push(record);
        });
    sortData.sortedData = sortedData;
    return sortData;
};
var MyPositions = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case MY_POSITIONS:
            return __assign(__assign({}, state), { data: action.payload.data });
        // case MY_POSITIONS_STREAM:
        //   return {
        //     ...state,
        //     data: {
        //       ...state.data,
        //       stockList: streamPerticuleWatchlist(
        //         state.data.stockList,
        //         action.payload as IStreamEntity
        //       ),
        //     },
        //   };
        case MY_POSITIONS_CLEAR_DATA:
            return __assign(__assign({}, state), { data: {} });
        case MY_POSITIONS_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case MY_POSITIONS_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initialState.errorData });
        case MY_POSITIONS_START_LOADER:
            return __assign(__assign({}, state), { loader: true });
        case MY_POSITIONS_STOP_LOADER:
            return __assign(__assign({}, state), { loader: false });
        case MY_POSITIONS_APPLY_SORT_:
            return __assign(__assign({}, state), { sortData: applySorting(action.payload) });
        case MY_POSITIONS_CLEAR_SORT:
            return __assign(__assign({}, state), { sortData: __assign(__assign({}, state.sortData), { sortedData: initialState.sortData.sortedData }) });
        default:
            return __assign({}, state);
    }
};
export default MyPositions;
